<template>
    <div class="basic_wrap">
		<div class="red_top_bg">
		    <div class="back_left" @click="$router.go(-1)"></div>
		    <div class="big_tit">{{$t('cash.withdraw')}}</div>
			<div class="top_right" @click="$router.push('/cashlist')">
				<van-icon name="bars" size="25"/>
			</div>
		</div>
		<div class="balance">
			<p>
				 {{utils_moneyMark()}} {{data.money}}
			</p>
			<p>
				{{$t('invest.availableBalance')}}   
			</p>
		</div>
	<!-- 	<div class="balance" >
			<dl class="ratio-info">
			    <dd><span class="text-gray">{{$t('cash.abletimes')}}：</span><em>{{data.cash_maxnum}} {{$t('cash.time')}}</em></dd>
			    <dd><span class="text-gray">{{$t('cash.usdtimes')}}：</span><em>{{data.cashnum}} {{$t('cash.time')}}</em></dd>
			    <dd><span class="text-gray">{{$t('cash.isable')}}：</span><em>{{$t('cash.yes')}}</em></dd>
			    <dd><span class="text-gray">{{$t('cash.mincash')}}：</span><em>{{utils_moneyMark()}} {{data.min_cash}} </em></dd>
			</dl>
		</div> -->
        <div class="wrap_box wrap1">
			<div class="withdraw_wrap">
				<p>{{$t('cash.amount')}}</p>
				<div class="flex_center" style="">
					<span>{{utils_moneyMark()}}</span>
					 <input
					  v-model="form.money" 
					  type="number"
					  step="1"
					  class="inp"
					  :placeholder="$t('cash.withdrawableAmount') + utils_moneyMark()+data.money"
					  @input="changeAmount"
					>
					<button class="allbtn" type="button"  @click="cashall()">
					{{$t('item.all')}}
					</button>
					
					<!-- <span>{{actualAmount}}</span> -->
				</div>
				<p v-if="chargeTip">{{chargeTip}}</p>
			</div>
			<div class="withdraw_wrap">
				<p>{{$t('shopd.region')}}</p>
				<div style="display: flex;">
					<input maxlength="6"  :placeholder="$t('d.withdrawpin')" max="999999" size="6" :type="newpasswordInp"  v-model="form.password" >
					<div class="eye_bi" @click="showNewsPwd" :class="newpasswordInp=='text'?'eye':''"></div>
				<!-- 	 <input
					  v-model="form.password" 
					  type="number"
					  class="inp"
					  :placeholder="$t('d.withdrawpin')"
					> -->
				</div>
			</div>
			<div class="choose_bank" @click="$router.push('/addr')">
				<div>
					<span>{{$t('cash.wallet')}}</span>
				</div>
				<div>
					<span>
						<span v-if="accaddr" style="margin-right: 10px;">{{accaddr}}<br/></span>
						{{bank_name}}
					</span>
					<van-icon name="arrow" color="#999"/>
				</div>
			</div>
			<!-- <div class="choose_bank">
				<div >
					<span >Wallet</span>
				</div>
				<div>
					<span >Add Fund Info</span>
					<i class="van-icon van-icon-arrow" style="color: rgb(153, 153, 153);">
					</i>
				</div>
			</div> -->
			<!-- <van-action-sheet
			  v-model="show"
			  :actions="actions"
			  :cancel-text="this.$t('shopd.cancelbtn')"
			  :description="this.$t('cash.chooseWallet')"
			  close-on-click-action
			  @click="doAddAddr"
			/> -->
            <p class="canal_tips">{{$t('cash.arrivalTime')}}</p>
        </div>
        <div class="basic_btn" @click="submit()">{{$t('utils.submit')}}</div>
        <van-popup v-model="write_psd" closeable close-icon="close" round position="bottom">
            <div class="psw_box">
                <van-password-input :value="psd_val" :mask="true" :focused="showKeyboard" @focus="showKeyboard = true" />
                <div class="keybord_box">
                    <div class="keybord">
                        <div class="key_item" v-for="i in 9" @click="onInput(i)">
                            <div class="key_inner">{{i}}</div>
                        </div>
                        <div class="key_item no_bg">
                            <div class="key_inner"></div>
                        </div>
                        <div class="key_item" @click="onInput(0)">
                            <div class="key_inner">0</div>
                        </div>
                        <div class="key_item no_bg x" @click="onDelete">
                            <div class="key_inner">x</div>
                        </div>
                    </div>
                </div>
            </div>
        </van-popup>
		<van-dialog
			 width="90%"
			v-model="show_tc"
			:confirmButtonText="$t('utils.confirm')">
			<!-- <img width="100%" src="../images/index/tanchuang.png"> -->
			<div class="popup" v-html="tc_content"></div>
		</van-dialog>
		<div v-show="setPwd" class="real_name_mask">
				<div class="real_box">
					<div class="tit" />
					<p class="tips">
						{{$t('cash.setPwdFirst')}}
					</p>
					<div class="basic_btn" @click="setIniPwd">
						{{$t('cash.setNow')}}
					</div>
				</div>
			</div>
		</div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Fetch from '../../utils/fetch'
    import {
        DropdownMenu,
        DropdownItem,
		Dialog,
		Popup,
		PasswordInput,
		NumberKeyboard,
		Icon,
		ActionSheet
    } from 'vant';
    Vue
	.use(Dialog)
	.use(PasswordInput)
	.use(NumberKeyboard)
	.use(Popup).use(DropdownMenu).use(DropdownItem).use(Icon).use(ActionSheet);

    export default {
        name: "cost",
        data() {
            return {
                data: {},
				newpasswordInp:'password',
                showKeyboard: true,
                write_psd: false,
                psd_val: '',
				chargeTip:'',
				charge:0,
                form: {
                    money: '',
                    password: '',
                    bank_id: 0,
                },
				eye:1,
				show: false,
				bank_name:this.$t('cash.chooseWallet'),
				actions: [],
				setPwd:false,
				submitType:1,
				type:1,
				accaddr:'',
				show_tc:false,
				tc_content:"",
				rate:1,
				mark:"$",
				actualAmount:''
            };
        },
        created() {
            this.$parent.footer('user', false);
        },
        mounted() {
            this.start();
        },
        methods: {
			showNewsPwd() {
			    this.newpasswordInp == 'password' ? this.newpasswordInp = 'text' : this.newpasswordInp = 'password'
			},
			cashall(){
				this.form.money = this.data.money;
				this.changeAmount();
			},
			doAddAddr(){
				if(this.form.bank_id==0){
					this.$router.push('/addcountUsdt')
				}
			},
			onSelect(item){
				this.chargeTip = "";
				this.actualAmount = "";
				this.form.money = "";
				this.accaddr = item.acc;
				this.show = false;
				this.bank_name = item.name;
				this.form.bank_id = item.value;
				this.charge = item.charge;
				this.type = item.type;
				this.rate = item.rate;
				this.mark = item.mark;
				if(item.charge>0){
					this.chargeTip = this.$t('cash.charge')+item.charge+"%";
				}else{
					this.chargeTip = "";
				}
				if(item.value==0){
					this.$router.push('/addcountUsdt')
				}
			},
			changeAmount(){
				this.chargeTip = "";
				var rateTip = "";
				var num = 2;
				this.form.money = parseInt(this.form.money);
					// if(this.type==1){
					// 	if(this.rate>10000){
					// 		num = 8;
					// 	}else if(this.rate>1000){
					// 		num = 6;
					// 	}else if(this.rate>10){
					// 		num = 4;
					// 	}
					// 	this.actualAmount = "≈"+(this.form.money/this.rate).toFixed(num)+this.mark;
					// 	rateTip = "≈"+(this.form.money*this.charge/100/this.rate).toFixed(num)+this.mark+"";
					// }else{
						this.actualAmount = "≈"+this.mark+(this.form.money/this.rate).toFixed(num);
						rateTip = "≈ $ "+(this.form.money*this.charge/100).toFixed(num)+" ";
					// }
				if(this.charge>0){
					this.chargeTip = this.$t('cash.charge')+""+rateTip;
					// this.chargeTip = this.$t('cash.charge')+":$"+(this.form.money*this.charge/100).toFixed(num)+rateTip;
				}
			},
            onInput(key) {
                this.psd_val = (this.psd_val + key).slice(0, 6);
                if (this.psd_val.length == 6) {
					this.write_psd = false;
					this.form.password = this.psd_val;
					if(this.submitType==1){
						this.submit();
					}else{
						this.setIniPwdSubmit();
					}
					
                }
            },
            onDelete() {
                this.psd_val = this.psd_val.slice(0, this.psd_val.length - 1);
            },
            subAll() {
                this.form.money = this.data.money;
            },
            start() {
                Fetch('/user/my_bank').then((r) => {
                    this.data = r.data;
					this.data.money = this.data.money.toFixed(2);
					this.setPwd = r.data.intPwd;
                    var bankvalue = [];
					if(r.data.bank){
						var item = r.data.bank;
						// r.data.bank.forEach(item => {
							// var length = item.account.length;
							var account = item.addr+"";
							var itemAccount = account;//.substr(length-10,length)
							var tmpi = {
								name: item.name,
								acc: itemAccount,
								value: item.id,
								charge:r.data.cash_rate,
								rate:r.data.cash_rate,
								type:1,
								mark:item.curname
							};
							bankvalue.push(tmpi);
							this.onSelect(tmpi);
						// })
						
						bankvalue.push()
						this.actions = bankvalue;
					}else{
						bankvalue.push({
							name: this.$t('cash.addWallet'),
							value: 0,
							color:"#FF0000",
						})
						this.actions = bankvalue;
					}
                });
				Fetch('/user/cash_search').then(r => {
				    var list = r.data;
					if(list && list.length>0){
						var item = list[0];
						if(item.status==2 && item.memo && item.memo.length>3){
							this.tc_content = item.memo;
							if(localStorage.getItem('tcid')!=item.id){
								localStorage.setItem('tcid',item.id);
								this.show_tc = true;
							}
						}
					}
					
				})
				
				
            },
            submit() {
				this.psd_val="";
                if (!this.form.money) {
                    this.$toast(this.$t('cash.withdrawalAmountEmpty'));
                    return false;
                }
                if(this.form.money < 0){
                    this.$toast(this.$t('cash.withdrawalAmountNotAllow'));
                    return false;
                }
				if(parseInt(this.form.money) > parseInt(this.data.money)){
                    this.$toast(this.$t('cash.withdrawalAmountHigh'));
                    return false;
                }
                // if (this.form.bank_id == 0 || this.form.bank_id == -1) {
                //     this.$toast(this.$t('cash.withdrawalAccountEmpty'));
                //     return false;
                // }
				if (!this.form.password) {
                    this.$toast(this.$t('cash.withdrawalPasswordEmpty'));
                    return false;
                }
                Fetch('/user/cost_apply', {
                    money: this.form.money,
                    bank_id: this.form.bank_id,
                    passwd: this.form.password
                }).then(() => {
                    this.$toast({
                        background: '#07c160',
                        message: this.$t('cash.success')
                    });
                    this.$router.replace('/user')
                });
            },
			setIniPwdSubmit(){
				this.psd_val="";
				Fetch('/user/setIniPwd', {
				    password: this.form.password
				}).then(() => {
					this.setPwd = false;
				});
			},
			setIniPwd(){
				this.submitType = 2;
				this.write_psd = true;
			}
        }
    };
</script>

<style lang="less" scoped>
	
	/deep/ .van-action-sheet__item {
	    text-align: left;
	}
	/deep/ .van-popup--bottom{
		border-radius:0;
		padding-bottom: 15px;
	}
	.balance{
		background: #ffffff;
		border-radius: 6px;
		padding: 20px 0px;
		text-align: center;
		margin: 10px;
		box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.1) 0px 2px 4px -2px;
		p:nth-child(1){
			font-size: 20px;
			font-weight: bold;
			margin-bottom: 15px;
		}
		p:nth-child(2){
			color: #999;
			font-weight: bold;
		}
	}

    .wrap1 {
        margin: 10px;
		box-shadow: none;
		background: none;
		.choose_bank{
			width: 100%;
			background: #FFFFFF;
			border-radius: 5px;
			padding:15px;
			display: flex;
			justify-content: flex-start;
			align-items: center;
			margin-top: 10px;
			box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.1) 0px 2px 4px -2px;
			div:nth-child(1){
				width: 20%;
				font-size: 14px;
				font-weight: bold;
				color: #999;
			}
			div:nth-child(2){
				width: 80%;
				text-align: right;
				font-size: 12px;
				font-weight: bold;
				color: #999;
			}
		}
		.withdraw_wrap{
			width: 100%;
			background: #ffffff;
			border-radius: 6px;
			padding: 16px 20px;
			margin-top: 10px;
			box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.1) 0px 2px 4px -2px;
			input{
				height: 18px;
				width: 70%;
				line-height: 18px;
				font-size: 14px;
			}
			div{
				span:nth-child(1){
					font-size: 18px;
					margin-right: 10px;
					font-weight: bold;
				}
				span:nth-child(2){
					font-size: 14px;
					margin-left: 20px;
					font-weight: bold;
					width: 15%;
					color: #999;
					text-align: right;
				}
			}
			p:nth-child(1){
				font-size: 14px;
				font-weight: bold;
				color: #999;
				margin-bottom: 20px;
			}
			p:nth-child(3){
				color: #999;
				margin-top: 20px;
			}
		
		}
    }
	.canal_tips {
		border-top: 1px solid #ECECEC;
		display: block;
		padding: 16px;
		border-radius: 5px;
		background-color: #FFFFFF;
		line-height: 24px;
		color: #D20100cc;
		font-size: 12px;
		margin-top: 10px;
		    box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.1) 0px 2px 4px -2px;
    }
    .basic_btn {
        margin: 53px auto 0 auto;
		border-radius: 5px;
    }
	
    /deep/ .van-password-input {
        margin: 50px 28px 0 28px;
    }

    /deep/ .van-hairline--left::after {
        border: 1px solid #ECECEC;
    }

    .van-password-input .van-password-input__security::after {
        border-radius: 0;
    }

    .keybord_box {
        height: 250px;
        background-color: #F0F0F0;
        margin-top: 35px;
        padding: 24px 12px 0 12px;

        .keybord {
            width: 361px;
            margin: 24px auto 0 atuo;
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            text-align: center;

            .key_item {
                width: 115px;
                height: 44px;
                line-height: 44px;
                font-size: 18px;
                font-weight: bold;
                margin-bottom: 6px;
                background: rgba(255, 255, 255, 1);
                border-radius: 3px;

                &.no_bg {
                    background: none;
                }

                &.x {
                    color: #757880;
                    font-weight: bold;
                }
            }
        }
    }
	
	.ratio-info{
	    display: grid;
	    grid-template-columns: repeat(2,1fr);
	    row-gap: 14px;
	    padding: 0px 20px;
	    line-height: 1;
		dd{
		    margin: 0;
		}
		em {
		    font-style: normal;
		    font-size: 14px;
		}
	}
	.text-gray {
	    color: #ababab;
	}
	.basic_wrap{
		position: relative;
		// height: 100vh;
	}
	/deep/ .van-popup--bottom{
		position: absolute;
	}
	/deep/ .van-popup--bottom{
		padding-bottom:0;
	}
	.allbtn{
		height: 25px;
		line-height: 20px;
		padding: 2px 8px;
		border-radius: 5px;
		margin-left: 10px;
		font-size: 10px;
		box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.1) 0px 2px 4px -2px;
		background-color: #232f3e;
		color: #ffcd00;
	}
	.eye_bi {
	    width: 21px;
	    height: 25px;
	    background: url(../images/user/eye2.png) no-repeat center center;
	    background-size: 100% auto;
	
	    &.eye {
	        background: url(../images/user/eye1.png) no-repeat center center;
	        background-size: 100% auto;
	    }
	}
	.popup{
		-webkit-box-flex: 1;
		-webkit-flex: 1;
		flex: 1;
		max-height: 60vh;
		padding: 20px;
		overflow-y: auto;
		font-size: 14px;
		line-height: 20px;
	}
</style>
